module.exports = __webpack_public_path__ + "img/brand-4.80901308.jpg";